import type { PropsWithChildren } from 'react';

import { FailReason, Step } from '@repo/common';

import { Layout } from '@/components/Layout/Layout';
import { Loading } from '@/components/Loading/Loading';
import { VerificationFailed } from '@/components/verification-result/verification-failed';
import { useAuthorize } from '@/hooks/use-authorize';
import { useAppContext } from '@/providers/app-provider/context';
import { selectStep } from '@/providers/app-provider/selectors';

export const AppContent = ({ children }: PropsWithChildren) => {
  const { state } = useAppContext();

  const { isAuthorized, loading } = useAuthorize();

  if (loading) {
    return <Loading />;
  }

  const showCancelVerification = isAuthorized && selectStep(state)?.value !== Step.MOBILE_REDIRECT_CANCELED;

  return (
    <Layout showCancelVerification={showCancelVerification}>
      {isAuthorized ? children : <VerificationFailed failReason={FailReason.UNAUTHORIZED} />}
    </Layout>
  );
};
